export * as TaskCenterTypes from './swagger/taskCenter/types';
export var SystemTaskStatus;
(function (SystemTaskStatus) {
    SystemTaskStatus["INCOMPLETE"] = "INCOMPLETE";
    SystemTaskStatus["COMPLETE"] = "COMPLETE";
    SystemTaskStatus["CLOSE"] = "CLOSE";
})(SystemTaskStatus || (SystemTaskStatus = {}));
export var SystemTaskStatusName;
(function (SystemTaskStatusName) {
    SystemTaskStatusName["INCOMPLETE"] = "\u5F85\u5904\u7406";
    SystemTaskStatusName["COMPLETE"] = "\u5DF2\u5B8C\u6210";
    SystemTaskStatusName["CLOSE"] = "\u5DF2\u5173\u95ED";
})(SystemTaskStatusName || (SystemTaskStatusName = {}));
export var TaskAttribute;
(function (TaskAttribute) {
    TaskAttribute["ALL"] = "ALL";
    TaskAttribute["INCOMPLETE"] = "INCOMPLETE";
    TaskAttribute["ABOUT_TO_TIMEOUT"] = "ABOUT_TO_TIMEOUT";
    TaskAttribute["TIMEOUT"] = "TIMEOUT";
    TaskAttribute["COMPLETE"] = "COMPLETE";
    TaskAttribute["CLOSE"] = "CLOSE";
})(TaskAttribute || (TaskAttribute = {}));
export var TaskType;
(function (TaskType) {
    TaskType["WHATSAPP"] = "REPLY_WHATSAPP";
    TaskType["FOLLOW_UP_CUSTOMER"] = "FOLLOW_UP_CUSTOMER";
    TaskType["REPLY_EMAIL"] = "REPLY_EMAIL";
    TaskType["REPLY_EDM"] = "REPLY_EDM";
    TaskType["SYSTEM"] = "SYSTEM_RESERVED";
})(TaskType || (TaskType = {}));
export var TaskCreateType;
(function (TaskCreateType) {
    TaskCreateType["UN_REPLY_CUSTOMER_EMAIL"] = "UN_REPLY_CUSTOMER_EMAIL";
    TaskCreateType["SITE_GUIDE_PUBLISH_REMINDER"] = "SITE_GUIDE_PUBLISH_REMINDER";
    TaskCreateType["MARKETING_WEEKLY_TASK"] = "MARKETING_WEEKLY_TASK";
})(TaskCreateType || (TaskCreateType = {}));
export var OperateTaskType;
(function (OperateTaskType) {
    OperateTaskType["COMPLETE"] = "COMPLETE";
    OperateTaskType["IGNORE"] = "IGNORE";
    OperateTaskType["CANCEL_IGNORE"] = "CANCEL_IGNORE";
})(OperateTaskType || (OperateTaskType = {}));
export const TaskTypeName = {
    [TaskType.WHATSAPP]: '回复WhatsApp任务',
    [TaskType.SYSTEM]: '系统任务',
    [TaskType.FOLLOW_UP_CUSTOMER]: '跟进客户',
    [TaskType.REPLY_EMAIL]: '回复邮件',
    [TaskType.REPLY_EDM]: '营销邮件',
};
export const TaskTabText = {
    [TaskAttribute.ALL]: '全部',
    [TaskAttribute.INCOMPLETE]: '待处理',
    [TaskAttribute.ABOUT_TO_TIMEOUT]: '即将超时',
    [TaskAttribute.TIMEOUT]: '已超时',
    [TaskAttribute.COMPLETE]: '已完成',
    [TaskAttribute.CLOSE]: '已忽略',
};
export var TaskPriorityStatus;
(function (TaskPriorityStatus) {
    TaskPriorityStatus[TaskPriorityStatus["HIGHEST"] = 1] = "HIGHEST";
    TaskPriorityStatus[TaskPriorityStatus["HIGH"] = 10] = "HIGH";
    TaskPriorityStatus[TaskPriorityStatus["NORMAL"] = 20] = "NORMAL";
    TaskPriorityStatus[TaskPriorityStatus["LOW"] = 30] = "LOW";
})(TaskPriorityStatus || (TaskPriorityStatus = {}));
export var NoviceTaskStatus;
(function (NoviceTaskStatus) {
    NoviceTaskStatus[NoviceTaskStatus["INCOMPLETE"] = 1] = "INCOMPLETE";
    NoviceTaskStatus[NoviceTaskStatus["COMPLETE"] = 2] = "COMPLETE";
    NoviceTaskStatus[NoviceTaskStatus["CLOSE"] = 3] = "CLOSE";
})(NoviceTaskStatus || (NoviceTaskStatus = {}));
export var SystemTaskConfigStatus;
(function (SystemTaskConfigStatus) {
    SystemTaskConfigStatus["IN_USE"] = "IN_USE";
    SystemTaskConfigStatus["DELETED"] = "DELETED";
})(SystemTaskConfigStatus || (SystemTaskConfigStatus = {}));
